module["exports"] = [
  "North",
  "East",
  "West",
  "South",
  "New",
  "Lake",
  "Port"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sk/address/city_prefix.js
// module id = 3539
// module chunks = 1610